module.exports = __webpack_public_path__ + "img/completed_icon.57eb5dfd.svg";